import { DialogContent } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import DialogView from '../../../../components/UI/DialogView';
import PrimaryButton from '../../../../components/UI/PrimaryButton';
import Row from '../../../../components/UI/Containers/Row';
import {
  HeaderText,
  MediumText,
} from '../../../../components/UI/Typography/PageHeader';
import Column from '../../../../components/UI/Containers/Column';
import DeleteImg from '../../../../assets/images/delete.svg';

function ConfirmationAlertView({
  isOpen,
  setOpen,
  onConfirm,
  //
  title,
  subTitle,

  //
  confirmBtnText,
  cancelBtnText,
  imageIcon,
}: {
  title?: string;
  subTitle: string;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  onConfirm?: () => void;
  //
  imageIcon?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
}) {
  const { t } = useTranslation();

  return (
    <DialogView maxWidth="xs" isOpen={isOpen} setOpen={setOpen}>
      <DialogContent className="col gap-5">
        <Column className="items-center gap-1">
          <img src={imageIcon ?? DeleteImg} className="w-28 mb-5" />
          {/* Header */}
          <HeaderText title={title ?? t('common.confirm_delete')} />
          {/* Sub Title */}
          <MediumText text={subTitle} />
        </Column>

        <Row className="w-full row justify-between gap-10 my-3">
          <PrimaryButton
            className="w-full h-11"
            variant={'outline'}
            title={cancelBtnText ?? t('pages.properties.edit_property.cancel')}
            onClick={() => setOpen(false)}
          />
          <PrimaryButton
            className="w-full h-11 bg-redBtnBg"
            variant={'secondary'}
            title={confirmBtnText ?? t('components.confirmation_dialog.confirm')}
            onClick={() => {
              setOpen(false);
              onConfirm && onConfirm();
            }}
          />
        </Row>
      </DialogContent>
    </DialogView>
  );
}

export default ConfirmationAlertView;
